import { getBrowserId, getCloudSDKSettingsBrowser as getCloudSDKSettings, getEnabledPackageBrowser as getEnabledPackage, getSettings, handleGetSettingsError } from '@sitecore-cloudsdk/core/internal';
import { getCookieValueClientSide } from '@sitecore-cloudsdk/utils';
import { ErrorMessages, PACKAGE_NAME } from '../../consts';
import { awaitInit } from '../../init/browser/initializer';
import { sendEvent } from '../send-event/sendEvent';
import { CustomEvent } from './custom-event';
/**
 * A function that sends an event to SitecoreCloud API with the specified type
 *
 * @param eventData - The required/optional attributes in order to be send to SitecoreCloud API
 * @returns The response object that Sitecore EP returns
 */
export async function event(eventData) {
    await awaitInit();
    if (getEnabledPackage(PACKAGE_NAME)?.initState) {
        const settings = getCloudSDKSettings();
        const id = getCookieValueClientSide(settings.cookieSettings.name.browserId);
        return new CustomEvent({
            eventData,
            id,
            sendEvent,
            settings: settings
        }).send();
    }
    else {
        const settings = handleGetSettingsError(getSettings, ErrorMessages.IE_0014);
        const id = getBrowserId();
        return new CustomEvent({
            eventData,
            id,
            sendEvent,
            settings
        }).send();
    }
}
